import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Select,
    MenuItem,
    FormControl,
    Box,
    Typography
} from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

const languages = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
    { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
    { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
    { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
    { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' },
    { code: 'sa', name: 'Sanskrit', nativeName: 'संस्कृत' }
];

const LanguageSwitcher = ({ compact = false }) => {
    const { i18n } = useTranslation();

    const handleLanguageChange = (event) => {
        const newLang = event.target.value;
        i18n.changeLanguage(newLang);
        localStorage.setItem('i18nextLng', newLang);




    };

    const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

    if (compact) {
        return (
            <FormControl size="small" sx={{ minWidth: { xs: 88, sm: 108 } }}>
                <Select
                    value={currentLanguage.code}
                    onChange={handleLanguageChange}
                    sx={{
                        '& .MuiSelect-select': {
                            py: 0.5,
                            px: { xs: 1, sm: 1.5 },
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }
                    }}
                >
                    {languages.map((lang) => (
                        <MenuItem key={lang.code} value={lang.code}>
                            <Typography variant="body2">{lang.nativeName}</Typography>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LanguageIcon fontSize="small" />
            <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select
                    value={i18n.language}
                    onChange={handleLanguageChange}
                    variant="standard"
                    disableUnderline
                    sx={{
                        '& .MuiSelect-select': {
                            py: 0,
                            fontSize: '0.875rem',
                            fontWeight: 500
                        }
                    }}
                >
                    {languages.map((lang) => (
                        <MenuItem key={lang.code} value={lang.code}>
                            {lang.nativeName}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};


export default LanguageSwitcher;
